import {
  useAddMaterial as useDomainAddMaterial,
  Material,
  MaterialsQueryKey
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {settingsQueryClient} from '../../../../modules/common/providers'
import {notifyIfErrorMessage} from '../../../../modules/common/utils/errorHandling'
import {ErrorResponse} from '../../../common/types'

export const useAddMaterial = (materials: Material[] | undefined) => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()
  return useDomainAddMaterial({
    onError: (error, variables) => {
      const data = error.response?.data as ErrorResponse | undefined

      const errorMessage = data?.message
      if (errorMessage?.endsWith('already exists.')) {
        const materialName = variables.dto.name
        const existingMaterial = materials?.find((material) => material.name === materialName)

        if (existingMaterial) {
          notify(
            'error',
            t('materialsSettings.materialNameAlreadyUsed', {
              materialName,
              materialType: existingMaterial.type
            })
          )
        } else {
          notify('error', t('materialsSettings.materialNameAlreadyUsedGeneric'))
        }
      } else {
        notifyIfErrorMessage(data?.detail ?? data?.message, raiseError, notify)
      }
    },
    onSuccess: (material, variables) => {
      notify('success', t('success.addMaterial'))
      const prevMaterials = settingsQueryClient.getQueryData<Material[]>([
        MaterialsQueryKey,
        variables.plantCode
      ])
      if (prevMaterials) {
        const newMaterials = [...prevMaterials, material]
        void settingsQueryClient.setQueryData(
          [MaterialsQueryKey, variables.plantCode],
          newMaterials
        )
      }
    }
  })
}
